import type { CSSProperties } from 'react';

const Style = {
  input: `relative block w-full p-3 rounded bg-white border border-solid border-slate-300 focus:bg-slate-50 focus:border-slate-400 appearance-none disabled:opacity-50`,
  selectedCanton: {
    fillColor: '#d32f2f',
    weight: 2,
    opacity: 1,
    color: 'white',
    dashArray: '3',
    fillOpacity: 0.5,
  },
  selectedMunicipality: {
    fillColor: '#d32f2f',
    weight: 2,
    opacity: 1,
    color: 'white',
    dashArray: '3',
    fillOpacity: 0.5,
  },
  modal: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 600,
    bgcolor: 'background.paper',
    border: '1px solid #f5f5f5',
    boxShadow: 24,
    p: 4,
  },
  legalBorder: { color: '#9c27b0', fillColor: '#9c27b0', fillOpacity: 0.3 },
  buildableBorder: { color: '#ed6c02', fillColor: '#ed6c02', fillOpacity: 0.3 },
  analysisArea: {
    color: '#d32f2f',
    fillColor: '#d32f2f',
    fillOpacity: 0.3,
  },
  customStyleForEditableCoordinatesContainer: {
    width: '700px',
    marginLeft: '20px',
    height: '400px',
    display: 'flex',
    flexDirection: 'column',
  } satisfies CSSProperties,
  customStyleForEditableCoordinates: {
    flex: 1,
    overflowY: 'auto',
    alignContent: 'start',
  } satisfies CSSProperties,
  hideEditAreaForLegalBorder: {
    width: '30px',
    height: '30px',
    backgroundColor: '#9c27b0',
    color: '#ffffff',
    borderRadius: 0,
  },
  hideEditAreaForBuildableBorder: {
    width: '30px',
    height: '30px',
    backgroundColor: '#ed6c02',
    color: '#ffffff',
    borderRadius: 0,
  },
  hideEditAreaForAnalysisArea: {
    width: '30px',
    height: '30px',
    backgroundColor: '#d32f2f',
    color: '#ffffff',
    borderRadius: 0,
  },
};

export default Style;
